const config = {
    BASE_URL: "https://storysetu.com/backadmin/",
  };
  //https://kahanifm.com/backadmin/
  //https://hamarafm.com/hfm/backadmin/
  //http://localhost:8080/
  export default config;
  